/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_ConciergeInputs */

const en_pricing_feature_concierge = /** @type {(inputs: Pricing_Feature_ConciergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24/7 Dedicated Concierge`)
};

const es_pricing_feature_concierge = /** @type {(inputs: Pricing_Feature_ConciergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conserje Dedicado 24/7`)
};

const fr_pricing_feature_concierge = /** @type {(inputs: Pricing_Feature_ConciergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concierge dédié 24h/24 et 7j/7`)
};

const de_pricing_feature_concierge = /** @type {(inputs: Pricing_Feature_ConciergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24/7 Dedizierter Concierge`)
};

const id_pricing_feature_concierge = /** @type {(inputs: Pricing_Feature_ConciergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pramutamu Dedikasi 24/7`)
};

/** @type {(inputs: Pricing_Feature_ConciergeInputs) => LocalizedString} */
const ja_pricing_feature_concierge = en_pricing_feature_concierge;

/** @type {(inputs: Pricing_Feature_ConciergeInputs) => LocalizedString} */
const zh_pricing_feature_concierge = en_pricing_feature_concierge;

/** @type {(inputs: Pricing_Feature_ConciergeInputs) => LocalizedString} */
const ar_pricing_feature_concierge = en_pricing_feature_concierge;

/** @type {(inputs: Pricing_Feature_ConciergeInputs) => LocalizedString} */
const it_pricing_feature_concierge = en_pricing_feature_concierge;

/** @type {(inputs: Pricing_Feature_ConciergeInputs) => LocalizedString} */
const ru_pricing_feature_concierge = en_pricing_feature_concierge;

/** @type {(inputs: Pricing_Feature_ConciergeInputs) => LocalizedString} */
const pt_pricing_feature_concierge = en_pricing_feature_concierge;

/** @type {(inputs: Pricing_Feature_ConciergeInputs) => LocalizedString} */
const ko_pricing_feature_concierge = en_pricing_feature_concierge;

/**
* | output |
* | --- |
* | "24/7 Dedicated Concierge" |
*
* @param {Pricing_Feature_ConciergeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_concierge = /** @type {((inputs?: Pricing_Feature_ConciergeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_ConciergeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_feature_concierge(inputs)
	if (locale === "es") return es_pricing_feature_concierge(inputs)
	if (locale === "fr") return fr_pricing_feature_concierge(inputs)
	if (locale === "de") return de_pricing_feature_concierge(inputs)
	if (locale === "ja") return ja_pricing_feature_concierge(inputs)
	if (locale === "zh") return zh_pricing_feature_concierge(inputs)
	if (locale === "ar") return ar_pricing_feature_concierge(inputs)
	if (locale === "id") return id_pricing_feature_concierge(inputs)
	if (locale === "it") return it_pricing_feature_concierge(inputs)
	if (locale === "ru") return ru_pricing_feature_concierge(inputs)
	if (locale === "pt") return pt_pricing_feature_concierge(inputs)
	return ko_pricing_feature_concierge(inputs)
});